<template>
    <div class="">
        <bubble-menu
            class="bubble-menu"
            :tippy-options="{ duration: 100 }"
            :editor="editor"
        >
            <button
                type="button"
                :class="[
                    editor.isActive('bold')
                        ? 'border-z-primary-400 bg-iron-800'
                        : 'border-iron-900 bg-iron-900',
                    'rounded-l-md p-2 border',
                ]"
                @click="editor.chain().focus().toggleBold().run()"
            >
                <Bold class="text-white" :size="16" stroke-width="2.2" />
            </button>
            <button
                type="button"
                :class="[
                    editor.isActive('italic')
                        ? 'border-z-primary-400 bg-iron-800'
                        : 'border-iron-900 bg-iron-900',
                    'p-2 border',
                ]"
                @click="editor.chain().focus().toggleItalic().run()"
            >
                <Italic class="text-white" :size="16" stroke-width="2.2" />
            </button>
            <button
                type="button"
                :class="[
                    editor.isActive('underline')
                        ? 'border-z-primary-400 bg-iron-800'
                        : 'border-iron-900 bg-iron-900',
                    'rounded-r-md p-2 border',
                ]"
                @click="editor.chain().focus().toggleUnderline().run()"
            >
                <UnderlineIcon
                    class="text-white"
                    :size="16"
                    stroke-width="2.2"
                />
            </button>
        </bubble-menu>

        <EditorContent :editor="editor"></EditorContent>
    </div>
</template>

<script lang="ts" setup>
import { Editor, BubbleMenu, EditorContent } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import { onBeforeUnmount } from "vue";
import { Bold, Italic, Underline as UnderlineIcon } from "lucide-vue-next";
import Underline from "@tiptap/extension-underline";

const model = defineModel<string>();

const editor = new Editor({
    content: `${model.value}`,
    extensions: [StarterKit, Underline],
    onUpdate({ editor }) {
        model.value = editor.getHTML();
    },
    editorProps: {
        attributes: {
            class: "min-h-[80px] max-w-[436px] focus:outline-none rounded-lg border border-iron-300 focus:border-z-primary-300 px-3 py-2 text-sm text-iron-900 shadow-xs ring-purple-100 focus:outline-none focus:ring-2",
        },
    },
});

onBeforeUnmount(() => {
    editor.destroy();
});
</script>
